import {Component, OnInit} from '@angular/core';
import {CommonService} from '../_services';
import {NavigationEnd, Router, RoutesRecognized} from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../environments/environment';
import swal from 'sweetalert2';
import {filter, pairwise} from 'rxjs/operators';

@Component({
  selector: 'app-industry-list',
  templateUrl: './industry-list.component.html',
  styleUrls: ['./industry-list.component.css']
})

export class IndustryListComponent implements OnInit {

  public apiBaseUrl: string = environment.apiBaseUrl;
  public state: string = environment.state;
  production = environment.production;
  route: string;
  allIndustriesDetails = [];
  allCityList = [];
  maxStartDate: Date;
  maxEndDate: Date;
  maxIniConnectedDate: Date;
  maxLastUpdateDate: Date;
  startReportDate = '';
  endReportDate = '';
  iniConnectedDate = '';
  lastUpdateDate = '';
  startReportTime: Date;
  endReportTime: Date;
  searchField = {
    'status': '',
    'indCategory': '',
    'district': '',
    'address': '',
    'vendorName': '',
    'industryId': '',
    'industryName': '',
    'emmisionType': '',
    'region': '',
    'categoryType': '',
    'startDate': '',
    'endDate': '',
    'iniConnectedDate': '',
    'lastUpdateDate': ''

  };
  regionList = [];
  userData: any = [];
  vendorList: any = [];
  userLevel = null;
  userName = null;
  industryIds = null;
  industryListLoader = false;
  previousUrl: string;
  currentUrl: string;

  constructor(private activeroute: ActivatedRoute, private router: Router,
              private _service: CommonService) {

    this.maxStartDate = new Date();
    this.maxEndDate = new Date();
    this.maxIniConnectedDate = new Date();
    this.maxLastUpdateDate = new Date();

    this.router.events
      .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
      .subscribe((events: RoutesRecognized[]) => {

        if (events[0].urlAfterRedirects != '/dashboard') {
          // this._service.ind_id = null;
        }
        console.log('previous url', events[0].urlAfterRedirects);
        console.log('current url', events[1].urlAfterRedirects);
      });
  }

  ngOnInit() {
    console.log('this.previousUrl', this.previousUrl);
    this.userData = JSON.parse(localStorage.getItem('userData'));
    if (this.userData) {
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];
    }

    if (this.userLevel == 'industry') {
      this.searchField['industryId'] = this.userName;
    }
    if (this._service.ind_id) {
      this.searchField['industry_ids'] = this.industryIds = this._service.ind_id;
    }

    if (this.userLevel == 'vendor') {
      this.searchField['vendorId'] = this.userData['id'] ? this.userData['id'] : '';
    }

    this.getVendorList();
    this.getRegionList();
    this.getCityList();
    this.getAllIndustryDetails();
  }

  getVendorList() {

    this.route = 'get-vendor-list';
    const token = localStorage.getItem('userToken');
    let data = {};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if (response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if (response.status == 200) {
        this.vendorList = response.data;
      }
    });

  }

  archiveIndustry(industryId) {
    swal({
      title: 'Are you sure?',
      text: 'You want to archive this industry!',
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then((willDelete) => {

      if (willDelete.value) {

        this.route = 'archive-industry';
        const token = localStorage.getItem('userToken');
        let data = {'industry_id': industryId};

        this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

          if (response.status == 204) {
            localStorage.removeItem('userToken');
            localStorage.removeItem('userData');
            this.router.navigate(['login']);
          }

          if (response.status == 200) {
            swal('Successfully archived industry details');
            this.getAllIndustryDetails();
          }
          if (response.status == 409) {
            swal('Archive not possible: ' + response.message);
            this.getAllIndustryDetails();
          }
        });

      } else {
        // swal("Industry deletion ");
      }

    });
  }

  deleteIndustry(industryId) {

    swal({
      title: 'Are you sure?',
      text: 'It will delete all the details related to this industry and once deleted, you will not be able to recover!',
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then((willDelete) => {

      if (willDelete.value) {

        this.route = 'delete-industry';
        const token = localStorage.getItem('userToken');
        let data = {'industry_id': industryId};

        this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

          if (response.status == 204) {
            localStorage.removeItem('userToken');
            localStorage.removeItem('userData');
            this.router.navigate(['login']);
          }

          if (response.status == 200) {
            swal('Successfully deleted industry details');
            this.getAllIndustryDetails();
          }
          if (response.status == 409) {
            swal('Deletion not possible: ' + response.message);
            this.getAllIndustryDetails();
          }
        });

      } else {
        // swal("Industry deletion ");
      }

    });

  }

  getRegionList() {
    this.route = 'get-region-list';
    const token = localStorage.getItem('userToken');

    let data = [];

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if (response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if (response.status == 200) {
        this.regionList = response.data;
      }
    });
  }

  getCityList() {

    this.route = 'get-all-city-list';
    const token = localStorage.getItem('userToken');
    let data = {};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if (response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }

      if (response.status == 200) {
        this.allCityList = response.data;
      }
    });

  }

  getAllIndustryDetails() {

    this.industryListLoader = true;
    this.route = 'get-all-industry-details';
    const token = localStorage.getItem('userToken');
    this.allIndustriesDetails = [];

    let data = {'search_fields': this.searchField};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if (response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if (response.status == 200) {
        this.allIndustriesDetails = response.data;
        const value = response.data[0].parameter_values;
        console.log(typeof value);

        if (typeof value === 'string') {
          this.allIndustriesDetails.forEach(value => {
            value.parameter_values = JSON.parse(value.parameter_values);
            value.parameter_values.forEach(param => {
              if (param.max !== null && param.min !== null) {
                if (param && !isNaN(Number(param.max)) && !isNaN(Number(param.current)) && !isNaN(Number(param.min))) {

                  if ((Number(param.max) < Number(param.current)) || (Number(param.min) > Number(param.current))) {
                    param.color = '#ff0000';
                  } else if ((Number(param.min) <= Number(param.current)) && (Number(param.current) <= Number(param.max))) {
                    param.color = '#008000';
                  }
                } else if (param.current === null) {
                  param.color = '#ffad00';
                } else {
                  param.color = '#2196F3';
                  console.log('1', param);
                }
              } else {
                param.color = '#9c9c9c';
                console.log('2', param, param.max === null, param.min === null);

              }


            });
          });
          console.log(this.allIndustriesDetails);
        }
      }
      this.industryListLoader = false;
      this.industryListLoader = false;
    });
  }

  exportReport(fileType) {

    var a;
    this.route = 'get-all-industry-details';
    let data = {'search_fields': this.searchField};
    const token = localStorage.getItem('userToken');

    a = document.getElementById('export' + fileType + 'href');
    a.href = this.apiBaseUrl + '/industry-list-export/' + fileType
      + '/' + (data['search_fields']['address'] ? btoa(data['search_fields']['address']) : btoa(null))
      + '/' + (data['search_fields']['categoryType'] ? btoa(data['search_fields']['categoryType']) : btoa(null))
      + '/' + (data['search_fields']['district'] ? btoa(data['search_fields']['district']) : btoa(null))
      + '/' + (data['search_fields']['emmisionType'] ? btoa(data['search_fields']['emmisionType']) : btoa(null))
      + '/' + (data['search_fields']['indCategory'] ? btoa(data['search_fields']['indCategory']) : btoa(null))
      + '/' + (data['search_fields']['industryId'] ? btoa(data['search_fields']['industryId']) : btoa(null))
      + '/' + (data['search_fields']['industryName'] ? btoa(data['search_fields']['industryName']) : btoa(null))
      + '/' + (data['search_fields']['region'] ? btoa(data['search_fields']['region']) : btoa(null))
      + '/' + (data['search_fields']['status'] ? btoa(data['search_fields']['status']) : btoa(null))
      + '/' + (data['search_fields']['vendorName'] ? btoa(data['search_fields']['vendorName']) : btoa(null))
      + '/' + (data['search_fields']['industry_ids'] ? btoa(data['search_fields']['industry_ids']) : btoa(null))
      + '/' + (data['search_fields']['startDate'] ? btoa(data['search_fields']['startDate']) : btoa(null))
      + '/' + (data['search_fields']['endDate'] ? btoa(data['search_fields']['endDate']) : btoa(null))
      + '/' + (data['search_fields']['iniConnectedDate'] ? btoa(data['search_fields']['iniConnectedDate']) : btoa(null))
      + '/' + (data['search_fields']['lastUpdateDate'] ? btoa(data['search_fields']['lastUpdateDate']) : btoa(null))

      + '/' + token;

    console.log(a);
    document.getElementById('export' + fileType + 'href').click();

  }

  onStartDateChange(value: Date): void {
    if (value) {
      this.startReportDate = this.convertDateFormat(value);
    } else {
      this.startReportDate = '';
    }

    this.searchField.startDate = this.startReportDate;
    // this.getAllIndustryDetails();
  }

  onEndDateChange(value: Date): void {
    if (value) {
      this.endReportDate = this.convertDateFormat(value);
    } else {
      this.endReportDate = '';
    }

    this.searchField.endDate = this.endReportDate;
    // this.getAllIndustryDetails();
  }

  onIniConnectedDateChange(value: Date): void {
    if (value) {
      this.iniConnectedDate = this.convertDateFormat(value);
    } else {
      this.iniConnectedDate = '';
    }

    this.searchField.iniConnectedDate = this.iniConnectedDate;
    this.getAllIndustryDetails();
  }

  onMaxLastUpdateDateChange(value: Date): void {
    if (value) {
      this.lastUpdateDate = this.convertDateFormat(value);
    } else {
      this.lastUpdateDate = '';
    }

    this.searchField.lastUpdateDate = this.lastUpdateDate;
    this.getAllIndustryDetails();
  }

  convertDateFormat(dateObj) {

    var result_date = new Date(dateObj);

    var str = result_date.getFullYear() + '-' +
      ((result_date.getMonth() + 1) > 9 ? (result_date.getMonth() + 1) : ('0' + (result_date.getMonth() + 1)))
      + '-' +
      (result_date.getDate() > 9 ? result_date.getDate() : ('0' + result_date.getDate()));

    return str;
  }

}
